/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */


/* ++++++++++ --------------- ARTICLE SENTIMENT V2 DIVISION : STYLES --------------- ++++++++++ */
export default theme => ({
    articlesentimentv2: {

    }
});
